
export const mapSiteProps = (sites) => {
	if (sites?.length) {
		sites = sites.map((site) => {
			const { siteId: siteID, name: siteName, ...mappedSite } = site;
			return { siteID, siteName, ...mappedSite };
		});
	}
	return sites;
};
